import React, { FunctionComponent } from "react";

import { AlignItems, Icon, IconColor, Layout, SpacingSize } from "@multiweb/reactComponents";
import { IconCode } from "@multiweb/types/contracts";

export type SubmenuRightPartComponentProps = {
    /** Příznak, zda je ikona zvýrazněná - využívá se pro zvýraznění ikony při najetí myši na prvek menu */
    isActive?: boolean;
};

/** Komponenta slouží jako pravá část pro položky v menu, které představují rozbalovací submenu. */
export const SubmenuRightPartComponent: FunctionComponent<SubmenuRightPartComponentProps> = ({
    isActive = false,
}) => (
    <Layout
        spacingSizeHorizontal={SpacingSize.xs}
        alignItems={AlignItems.center}
    >
        <Icon
            iconCode={IconCode.uiChevronRightSmall}
            color={isActive ? IconColor.whiteFixed : IconColor.grey1}
        />
    </Layout>
);
